"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _uploads = require("./uploads");
Object.keys(_uploads).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _uploads[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _uploads[key];
    }
  });
});